import PageFallback from 'components/PageFallback';
import { lazy, Suspense } from 'react';

let ShareLocation = lazy(() => import('./ShareLocation'));

export async function lazyShareLocationLoader() {
    const componentModule = await import('./ShareLocation');
    // This avoid flicker from React.lazy by using the component directly
    ShareLocation = componentModule.default as any;

    return null;
}

export function LazyShareLocation() {
    return (
        <Suspense fallback={<PageFallback />}>
            <ShareLocation />
        </Suspense>
    );
}
